import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { useMount, useTimeout } from 'react-nb-hooks'

import { actions as LKModalActions } from '../shared/LKModal'
import STKExpiringWarning from './STKExpiringWarning'
import { setSTKExpired, logout, getSession } from '../../store/auth'

const TIMEOUT = 1000 * 60

const STKNotifications = () => {
  const dispatch = useDispatch()

  const [expirationWarningDelay, setExpirationWarningDelay] = React.useState(null)
  const [expiredDelay, setExpiredDelay] = React.useState(null)

  const { STKExpire } = useSelector(getSession)

  useMount(() => {
    const currentTimestamp = moment.now().valueOf()

    const expireWarningAfter = STKExpire - currentTimestamp - TIMEOUT
    if (expireWarningAfter > 0) {
      setExpirationWarningDelay(expireWarningAfter)
    }

    const expireAfter = STKExpire - currentTimestamp
    if (expireAfter > 0) {
      setExpiredDelay(expireAfter)
    }
  })

  useTimeout(() => dispatch(LKModalActions.open({ name: 'STKExpiring' })), expirationWarningDelay)
  useTimeout(
    () => dispatch([logout({ hard: false, reason: 'უმოქმედობის გამო სესიის დრო ამოიწურა' }), setSTKExpired(true)]),
    expiredDelay,
  )

  return <STKExpiringWarning />
}

export default STKNotifications
